import React from "react";
import classnames from "classnames";
import { propToCssModule } from "~/Classes/styles";
import ButtonNew from "~/Common-Objects/UI/Button";
import * as styles from "./index.module.scss";

const ConversationsButton = React.forwardRef(
  ({ variant, iconOnly, className, ...rest }, forwardedRef) => {
    const classes = classnames(styles.root, className, {
      [styles[`rootVariant${propToCssModule(variant)}`]]: variant,
      [styles.rootIconOnly]: iconOnly,
    });

    return (<>
      <ButtonNew
        ref={forwardedRef}
        variant={variant}
        iconOnly={iconOnly}
        className={classes}
        {...rest}
      />
    </>
    );
  }
);

export default ConversationsButton;
